import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialComponent } from './social/social.component';
import { GtmTrackModule } from '../../utils/directives/gtm-track/gtm-track.module';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneCodeModule } from '../../shared/components/phone-code/phone-code.module';
import { KzButtonModule } from '../../kz-ui/ui/form/button/kz-button.module';
import { KzFormModule } from '../../kz-ui/ui/form/kz-form.module';
import { KzTooltipModule } from 'src/app/kz-ui/ui/tooltip/kz-tooltip.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    SocialComponent,
    LegalNoticeComponent,
  ],
  imports: [
    CommonModule,
    GtmTrackModule,
    FormsModule,
    ReactiveFormsModule,
    PhoneCodeModule,
    KzButtonModule,
    KzFormModule,
    KzTooltipModule,
    RouterModule
  ],
  exports: [
    SocialComponent,
    LegalNoticeComponent,
  ],
  providers: []
})
export class AuthSharedModule {}
